import { FlowDeliverComponent } from './deliver.component';

export default FlowDeliverComponent;
